import { render, staticRenderFns } from "./schoolDialog.vue?vue&type=template&id=4e4ccd23"
import script from "./schoolDialog.vue?vue&type=script&lang=js"
export * from "./schoolDialog.vue?vue&type=script&lang=js"
import style0 from "./schoolDialog.vue?vue&type=style&index=0&id=4e4ccd23&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports